/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-icon-crop {
  align-items: center;
  display: flex;
  justify-content: center;
}

.qds-icon {
  flex-shrink: 0;
  transform: scaleX(var(--qds-direction-factor, 1));
}

.qds-standalone-link {
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  print-color-adjust: exact;
  text-decoration: none;
  width: 100%;

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }

  &:hover,
  &:active {
    text-decoration: underline;
  }
}

.qds-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

[data-importance='subdued'] {
  color: var(--qds-theme-link-subdued-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-subdued-hover);
  }

  &:active {
    color: var(--qds-theme-link-subdued-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='standard'] {
  color: var(--qds-theme-link-standard-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-standard-hover);
  }

  &:active {
    color: var(--qds-theme-link-standard-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='emphasized'] {
  color: var(--qds-theme-link-emphasized-default);

  &:visited.qds-visitable {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-emphasized-hover);
  }

  &:active {
    color: var(--qds-theme-link-emphasized-pressed);
  }

  &:visited:hover.qds-visitable {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active.qds-visitable {
    color: var(--qds-theme-link-visited-pressed);
  }
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-size='small'] {
  &.qds-standalone-link {
    font: var(--qds-control-small-link);
    gap: var(--qds-control-small-gap-internal);
    padding-block: var(--qds-control-small-padding-auto-height);
    min-height: var(--qds-control-small-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-small-text);
  }

  &.qds-icon-crop {
    height: var(--qds-control-small-icon-crop-height);
  }

  &.qds-icon {
    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }
}

[data-size='standard'] {
  &.qds-standalone-link {
    font: var(--qds-control-standard-link);
    gap: var(--qds-control-standard-gap-internal);
    padding-block: var(--qds-control-standard-padding-auto-height);
    min-height: var(--qds-control-standard-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-standard-text);
  }

  &.qds-icon-crop {
    height: var(--qds-control-standard-icon-crop-height);
  }

  &.qds-icon {
    height: var(--qds-control-standard-icon-size);
    width: var(--qds-control-standard-icon-size);
  }
}

[data-size='large'] {
  &.qds-standalone-link {
    font: var(--qds-control-large-link);
    gap: var(--qds-control-large-gap-internal);
    padding-block: var(--qds-control-large-padding-auto-height);
    min-height: var(--qds-control-large-height);
  }

  &[data-importance='subdued'] {
    font: var(--qds-control-large-text);
  }

  &.qds-icon-crop {
    height: var(--qds-control-large-icon-crop-height);
  }

  &.qds-icon {
    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }
}
